import styled, { css } from 'styled-components';
import {
	media,variables
} from 'styledComponents/utils';

export const KitWrapper = styled.div`
  width: 100%;
  height: auto;
  ${media.desktop`
    margin-top: 25px;
  `}
  h2 {
    margin-bottom: 8px;
    line-height: 24px !important;
    font-size: 16px !important;
    position: relative;
    span {
      font-size: 16px;
      line-height: 16px;
      &.light {
        color: #8B8A87;
        ${media.desktop`
          position: relative;
        `}
      }
      ${media.desktop`
        position: absolute;
        right: 0;
      `}
    }
  }
  hr {
    background-color: #D9D9D9;
  }
`;

export const KitImage = styled.div`
  background-image: url('https://assets.apostrophe.com/img/newCheckout/kit_image_blank_zoom.png');
  background-position-y: -25px;
  ${props => props.screen && css`
    background-image: url('https://assets.apostrophe.com/img/OTCs/screensmear.png');
  `};
  background-size: cover;
  width: 100%;
  height: 175px;
  margin-bottom: 28px;
  position: relative;
  ${media.tablet`
    height: 220px;
    background-position: right 0px top -50px;
    background-image: url('https://assets.apostrophe.com/img/newCheckout/kit_image_blank.png');
    ${props => props.screen && css`
      background-image: url('https://assets.apostrophe.com/img/OTCs/screensmear.png');
    `};
  `}
  ${media.desktop`
    width: 112px;
    height: 128px;
    min-width: 112px;
    min-height: 128px;
    margin-right: 16px;
    background-position: initial;
    background-image: url('https://assets.apostrophe.com/img/newCheckout/kit_image_small_blank.png');
    ${props => props.screen && css`
      margin-bottom: 0;
      background-image: url('https://assets.apostrophe.com/img/OTCs/screen_small.png');
      background-position-x: -28px;
    `};
  `}
`;

export const PriceTag = styled.div`
  position: absolute;
  width: 60px;
  height: 22px;
  background: white;
  top: 8px;
  left: 8px;
  font-family: 'GT-Pressura';
  text-transform: uppercase;
  font-size: 10px;
  line-height: 10px;
  ${props => props.screen && css`
    width: 111px;
  `};
  ${media.desktop`
    display: none;
  `}
`;

export const InnerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 6px;
  align-items: center;
`;

export const Triangle = styled.div`
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top: 0;
  border-bottom: 11px solid white;
  position: absolute;
  right: -6px;
  bottom: 0;
`;

export const UpsideDownTriangle = styled.div`
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top: 0;
  border-bottom: 11px solid white;
  position: absolute;
  right: -6px;
  top: 0;
  transform: rotate(180deg);
`;

export const LineItem = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
  height: auto;
  margin-bottom: 24px;
  ${media.tablet`
    justify-content: flex-start;
    width: 100%;
  `}
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  min-height: 24px;
  min-width: 24px;
  margin-right: 15px;
  ${props => props.natural && css`
    width: 30px;
    height: 30px;
    min-height: 30px;
    min-width: 30px;
    margin-left: -5px;
  `};
  svg {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const TextFlex = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  p {
    font-size: 12px;
    line-height: 16px;
    color: #000000;
    text-transform: none;
    width: 100%;
    margin: 0;
    margin-bottom: 8px;
    &.bold {
      font-family: 'GT-Pressura';
      text-transform: uppercase;
    }
    &.light {
      color: #8B8A87;
      font-size: 12px;
      line-height: 14px;
      .line-through {
        text-decoration: line-through;
      }
      span {
        margin-right: 4px;
      }
    }
  }
  h5 {
    font-size: 12px;
    line-height: 16px;
    text-decoration-line: underline;
    font-weight: 100;
    margin: 0;
    cursor: pointer;
  }
`;

export const ProductInfoWrapper = styled.div`
  position: relative;
  padding-bottom: 25px;
  ${media.desktop`
    width: 100%;
    padding-bottom: 0;
  `}
  h5 {
    font-size: 12px;
    line-height: 16px;
    color: #8B8A87;
    margin-top: 8px;
    font-weight: 100;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  h3 {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
  h4 {
    font-size: 16px;
    line-height: 16px;
    margin: 0;
  }
  h5 {
    font-size: 12px;
    line-height: 16px;
    text-decoration-line: underline;
    cursor: pointer;
    color: #000000;
    margin: 0;
    ${media.desktop`
      position: absolute;
      left: 0;
      bottom: 0;
    `}
  }
  h6 {
    font-size: 12px;
    line-height: 17px;
    margin: 0;
    font-weight: 400;
    ${media.desktop`
      position: absolute;
      right: 0;
      bottom: 0;
    `}
  }
`;

export const InnerContainer = styled.div`
  .sub-header {
    font-size: 12px;
    line-height: 16px;
    color: #000000;
    text-transform: none;
    width: 100%;
    margin: 0;
    margin-bottom: 28px;
    ${media.desktop`
      max-width: 280px;
    `}
  }
`;

export const DesktopFlex = styled.div`
  ${media.desktop`
    display: flex;
    ${props => props.screen && css`
      padding-bottom: 47px;
    `};
  `}
`;
